/**
Author - Brijesh Pandey
Git - https://bitbucket.org/__brijesh/
**/

import Form from "./Form.container";

export default Form;
